import { createTheme } from '@mui/material/styles';

export const salonTheme = createTheme({
  palette: {
    primary: {
      main: '#E91E63', // Rose pink - elegant and feminine
      light: '#F8BBD9',
      dark: '#AD1457',
      contrastText: '#ffffff',
    },
    secondary: {
      main: '#9C27B0', // Purple - luxury and sophistication
      light: '#CE93D8',
      dark: '#6A1B9A',
      contrastText: '#ffffff',
    },
    background: {
      default: '#FFF8F5', // Warm off-white
      paper: '#FFFFFF',
    },
    text: {
      primary: '#2D2D2D',
      secondary: '#666666',
    },
    success: {
      main: '#4CAF50',
    },
    warning: {
      main: '#FF9800',
    },
    error: {
      main: '#F44336',
    },
    info: {
      main: '#00BCD4',
    },
  },
  typography: {
    fontFamily: '"Poppins", "Inter", "Roboto", "Helvetica", "Arial", sans-serif',
    h1: {
      fontWeight: 600,
      color: '#2D2D2D',
      letterSpacing: '-0.02em',
    },
    h2: {
      fontWeight: 600,
      color: '#2D2D2D',
      letterSpacing: '-0.01em',
    },
    h3: {
      fontWeight: 600,
      color: '#2D2D2D',
    },
    h4: {
      fontWeight: 500,
      color: '#2D2D2D',
    },
    h5: {
      fontWeight: 500,
      color: '#2D2D2D',
    },
    h6: {
      fontWeight: 500,
      color: '#2D2D2D',
    },
    body1: {
      color: '#2D2D2D',
      lineHeight: 1.6,
    },
    body2: {
      color: '#666666',
      lineHeight: 1.5,
    },
  },
  components: {
    MuiAppBar: {
      styleOverrides: {
        root: {
          backgroundColor: '#FFFFFF',
          color: '#2D2D2D',
          boxShadow: '0 2px 12px rgba(233, 30, 99, 0.1)',
          borderBottom: '1px solid #F5F5F5',
        },
      },
    },
    MuiDrawer: {
      styleOverrides: {
        paper: {
          backgroundColor: '#1A1A1A',
          color: '#FFFFFF',
          background: 'linear-gradient(135deg, #E91E63 0%, #AD1457 100%)',
        },
      },
    },
    MuiListItemButton: {
      styleOverrides: {
        root: {
          borderRadius: '8px',
          margin: '4px 8px',
          color: '#FFFFFF',
          '&:hover': {
            backgroundColor: 'rgba(255, 255, 255, 0.2)',
          },
          '&.Mui-selected': {
            backgroundColor: 'rgba(255, 255, 255, 0.3)',
            '&:hover': {
              backgroundColor: 'rgba(255, 255, 255, 0.4)',
            },
          },
          '& .MuiListItemIcon-root': {
            color: '#FFFFFF',
          },
          '& .MuiListItemText-primary': {
            color: '#FFFFFF',
            fontWeight: 500,
          },
        },
      },
    },
    MuiCard: {
      styleOverrides: {
        root: {
          boxShadow: '0 4px 20px rgba(0,0,0,0.08)',
          borderRadius: '16px',
          border: '1px solid #F5F5F5',
          transition: 'all 0.3s ease',
          '&:hover': {
            boxShadow: '0 8px 30px rgba(233, 30, 99, 0.15)',
            transform: 'translateY(-2px)',
          },
        },
      },
    },
    MuiButton: {
      styleOverrides: {
        root: {
          borderRadius: '12px',
          textTransform: 'none',
          fontWeight: 500,
          padding: '10px 24px',
          boxShadow: 'none',
          '&:hover': {
            boxShadow: '0 4px 12px rgba(233, 30, 99, 0.3)',
          },
        },
        contained: {
          background: 'linear-gradient(135deg, #E91E63 0%, #AD1457 100%)',
          '&:hover': {
            background: 'linear-gradient(135deg, #AD1457 0%, #880E4F 100%)',
          },
        },
      },
    },
    MuiChip: {
      styleOverrides: {
        root: {
          borderRadius: '20px',
          fontWeight: 500,
        },
        colorPrimary: {
          background: 'linear-gradient(135deg, #E91E63 0%, #AD1457 100%)',
          color: '#FFFFFF',
        },
      },
    },
    MuiTextField: {
      styleOverrides: {
        root: {
          '& .MuiOutlinedInput-root': {
            borderRadius: '12px',
            '&:hover .MuiOutlinedInput-notchedOutline': {
              borderColor: '#E91E63',
            },
          },
        },
      },
    },
    MuiPaper: {
      styleOverrides: {
        root: {
          borderRadius: '16px',
        },
      },
    },
  },
});
